import { Pipe, PipeTransform } from '@angular/core';
import { PropertyStoreService } from '../services/stores/property-store.service';
import DateUtils from '../util/date-utils';

@Pipe({
   standalone: true,
   name: 'DatePropertyTimezone'
})
export class DatePropertyTimezonePipe implements PipeTransform {
   currentPropertyTimezone: string;

   constructor(private _propertyStore: PropertyStoreService) {
      //Set's property Tz to the users local, this is just in case of errors or issues with getting the property
      this.currentPropertyTimezone = this.GetLocalTimezone();
      _propertyStore.currentProperty.subscribe((property) => {
         if (property && property.timeZone) {
            this.currentPropertyTimezone = property.timeZone;
         }
      });
   }

   transform(value: unknown, includeTime = false, isUtc = false) {
      return DateUtils.parseDateStringToLocalStringFormat(
         value,
         includeTime,
         isUtc,
         this.currentPropertyTimezone
      );
   }

   private GetLocalTimezone(): string {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
   }
}
